export default [{
  path: '/payments-expense',
  name: 'payments_expenses',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/paymentsExpense/index')
}]

